import constants from '../constants'
// import InfluencerImg1 from '../assets/images/influencer1.webp'
// import InfluencerImg2 from '../assets/images/influencer2.webp'
// import InfluencerImg3 from '../assets/images/influencer3.webp'
// import InfluencerImg4 from '../assets/images/influencer4.webp'
// import InfluencerImg5 from '../assets/images/influencer5.webp'
// import InfluencerImg6 from '../assets/images/influencer6.webp'
// import InfluencerImg7 from '../assets/images/influencer7.webp'
// import InfluencerImg8 from '../assets/images/influencer8.webp'
import InfluencerImg10 from '../assets/images/home_banner_10.webp'
import InfluencerImg11 from '../assets/images/home_banner_11.webp'
// import InfluencerImg4Tamil from '../assets/images/influencer4_tamil.webp'
// import InfluencerImg4Kannada from '../assets/images/influencer4_kannada.webp'

export const deeplinks = {
  'anaya-care': 'https://mytatva.page.link/SIGRIMA',
  'bilypsa-care': 'https://mytatva.page.link/BILYPSA',
  'prostate-care': 'https://mytatva.page.link/PROSTATE',
  'akumentis-care': 'https://mytatva.page.link/AKUMENTIS',
}

export const programNames = {
  [constants.CARE_PROGRAM_TYPE.ANAYA]: 'Anaya Care Program',
  [constants.CARE_PROGRAM_TYPE.BILYPSA]: 'Ayushman Liver Care Program',
  [constants.CARE_PROGRAM_TYPE.PROSTATE]: 'Prostate Care Program',
  [constants.CARE_PROGRAM_TYPE.AKUMENTIS]: 'Akumentis Care Program',
}

export const DEFAULT_ADDRESS_TYPE = 'Other'
export const SOURCE_STORE_KEY = 'source'
export const DEFAULT_VENDOR_FLAG = 'redcliff'
export const DEV_FLAGS = ['development', 'uat']
export const GOODFLIP_DIAGNOSTIC_REPORT_TYPE = 'goodflipDiagnosticReport'
export const DEFAULT_REPORT_EMAIL = 'reports@tatvacare.in'

export const getValueFromKey = (language, videoIdMap) => {
  return videoIdMap[language] || videoIdMap['English']
}

export const getInfluencerCardsData = (selectedLanguage = 'English') => {
  const allCards = {
    shared: [
      // {
      //   id: 4,
      //   imageMap: {
      //     English: InfluencerImg4,
      //     தமிழ்: InfluencerImg4Tamil,
      //     ಕನ್ನಡ: InfluencerImg4Kannada,
      //     // తెలుగు: placeholder for future use
      //   },
      //   videoIdMap: {
      //     English: 'trVDkUv5LpU',
      //     தமிழ்: 'PSDZ0ICjjXY',
      //     ಕನ್ನಡ: 'TodWpeYpd8k',
      //     // తెలుగు: 'MyT5bLvlUes',
      //   },
      // },
    ],
    English: [
      // {
      //   id: 8,
      //   image: InfluencerImg8,
      //   videoId: 'E_-yVJsULZk',
      // },
      // {
      //   id: 6,
      //   image: InfluencerImg7,
      //   videoId: 'BOXB01O1LmU',
      // },
      // {
      //   id: 7,
      //   image: InfluencerImg6,
      //   videoId: '9OoY53Ngduk',
      // },
      // {
      //   id: 5,
      //   image: InfluencerImg5,
      //   videoId: 'bXLqMedwz_I',
      // },
      // {
      //   id: 3,
      //   image: InfluencerImg1,
      //   videoId: 'MHSVDWZnXqQ',
      // },
      // {
      //   id: 2,
      //   image: InfluencerImg2,
      //   videoId: 'qnYpXHOVYY0',
      // },
      // {
      //   id: 1,
      //   image: InfluencerImg3,
      //   videoId: 'fAun0a3zTlA',
      // },
      {
        id: 10,
        image: InfluencerImg10,
        videoId: 'E-tAC0X40t0',
      },
      {
        id: 11,
        image: InfluencerImg11,
        videoId: 'GiwdaNp7h4Y',
      },
    ],
  }

  const sharedCards = allCards.shared.map((card) => ({
    id: card.id,
    image: card.imageMap[selectedLanguage] || card.imageMap.English,
    videoId: card.videoIdMap[selectedLanguage] || card.videoIdMap.English,
  }))

  return [
    ...sharedCards,
    ...(selectedLanguage === 'English' ? allCards.English : []),
  ].sort((a, b) => b.id - a.id)
}

export const CKD_PHASE = 2
